<div class="container mt-4">
  <div class="row mt-3 mb-4 d-flex justify-content-center">
    <p class="text-center">{{ thankYouMessage }}</p>
  </div>
</div>

<div *ngIf="isAdestraTagReady">
  <img src="http://mail.identibase.co.uk/v/?tag={{ identiSubAdestraTag }}" />
</div>
